<template>
<v-card>
<v-card-text>
<v-icon @click="$emit('close')" class="fs-36 c-gray float-right mr-1 mt-1">close</v-icon>
<v-container class="mxw-1200" fill-height="">
<v-row class="align-center justify-center mb-2">
<v-col class="ta-center" v-if="photos.length > 1" xs="1">
<img :src="$assets.icons.chevron_left" @click="previousPhoto()" class="pointer w-100pc" style="opacity: 0.5" />
</v-col><v-col lg="7" md="7" sm="7" xs="10">
<v-img :src="first_photo" class="mb-2" max-height="400px" style="border-radius: 4px;">
</v-img></v-col><v-col class="ta-center" v-if="photos.length > 1" xs="1">
<img :src="$assets.icons.chevron_right" @click="nextPhoto()" class="pointer w-100pc" style="opacity: 0.5" />
</v-col><v-col lg="3" md="3" sm="3" v-if="photos.length > 1" xs="12">
<div class="mb-2" v-for="(photo, index) in preview_photos" :key="index">
<v-img :src="photo" max-height="125px" style="border-radius: 4px;">

</v-img></div></v-col></v-row></v-container><v-container class="mx-auto mxw-800">
<v-row class="mb-2">
<v-col class="pxy-0">
<div class="float-right">
<b-favorite :match_id="match.id">
</b-favorite></div><div class="c-black fw-500 fs-32 fs-xs-18" v-text="match.name">

</div></v-col></v-row><v-row class="mb-2">
<v-col class="pxy-0">
<div class="d-inline-block fs-16 fw-500">
<span>{{ match.address1 }}, {{ match.city }}, {{ match.zip }}</span>
</div><div class="d-inline-block ml-3" v-if="match.added_transit_time">
<v-icon>commute</v-icon>
<span class="fs-16 fw-500 ml-1" style="vertical-align: text-top;">+ {{ parseInt(match.added_transit_time / 60) }} minutes to your commute
</span>
</div></v-col></v-row><v-row class="mb-2" v-if="match.hours_description">
<v-col class="fs-16 fw-500 pxy-0">
<span v-text="match.hours_description">
</span><v-icon class="c-dark-blue fs-18 ml-1 v-align-bottom" v-if="match.hours_coverage">check_circle
</v-icon>
</v-col></v-row><v-row class="mb-2" v-if="match.ages_description">
<v-col class="fs-16 fw-500 pxy-0">
<div class="fs-16 fw-500">
<span v-text="match.ages_description">
</span><v-icon class="c-dark-blue fs-18 ml-1 v-align-bottom" v-if="match.ages_coverage">check_circle
</v-icon>
</div></v-col></v-row><v-row class="mb-0">
<b-parent-rating :match="match">
</b-parent-rating></v-row><v-row class="mb-4">
<b-state-rating :match="match">

</b-state-rating></v-row><v-row class="mb-0">
<v-col class="pxy-0">
<div class="fs-22 fw-500 mb-3">Rates & Availability</div>
</v-col></v-row><v-row class="mb-4">
<v-col class="c-dark-blue fs-16 fw-600 pxy-0">
<div @click="requestAvailability()" class="d-inline-block pointer" v-if="!availability_requested">
<img class="v-align-bottom mr-2" height="22" src="https://bridgecarefinance-media.s3-us-west-2.amazonaws.com/icons/refresh.svg" width="22" />
<span class="c-primary fs-14">REQUEST AVAILABILITY & TUITION</span>
</div><div class="d-inline-block" v-else="">
<img class="v-align-bottom mr-2 spin" height="22" src="https://bridgecarefinance-media.s3-us-west-2.amazonaws.com/icons/refresh.svg" width="22" />
<span class="c-primary fs-14 fw-600">AVAILABILITY & TUITION REQUESTED
</span>
</div></v-col></v-row><v-row class="mb-2" v-if="reviews.length > 0">
<v-col class="pxy-0">
<div class="fs-22 fw-500 mb-3">Reviews</div>
<div :key="review.url" class="mb-2" v-for="review in reviews">
<p class="mb-1 fs-16">{{ review.text }}</p>
<p>
<a :href="review.url" target="_blank">
<star-rating :active-color="$assets.theme.primary" :inactive-color="$assets.subtheme.pale_primary" :increment="0.25" :max-rating="5" :show-rating="false" :star-size="18" class="d-inline-block" read-only="" v-model="review.score">
</star-rating><img :src="review.icon" class="d-inline-block ml-2 va-baseline" height="16" />
<span class="ml-2 fs-14">{{ review.author }}, {{ review.year }}
</span>
</a></p></div></v-col></v-row></v-container></v-card-text><v-dialog v-model="inquiryDialogIsVisible" width="400px">
<v-card>
<v-card-text class="pxy-5 ta-center">
<div class="fs-22 fw-500 c-dark-blue mb-2">Request sent!</div>
<div class="fs-16 fw-500 c-dark-blue mb-2">We'll send you an email as soon as we confirm availability and pricing with <span class="underlined">{{ match.name }}</span>.</div>
<v-btn @click="inquiryDialogIsVisible=false" color="secondary" small="">Ok!
</v-btn>
</v-card-text></v-card></v-dialog></v-card></template>

<script>
import Favorite from './favorite.vue'
import StarRating from 'vue-star-rating'
import ParentRating from './parent_rating.vue'
import StateRating from './state_rating.vue'

export default {
  components: {
    'b-favorite': Favorite,
    'b-parent-rating': ParentRating,
    'b-state-rating': StateRating,
    'star-rating': StarRating
  },

  computed: {
    first_photo: function() {
      return this.photos[this.photo_index]
    },

    google_photos: function() {
      if(this.match.google_place) {
        return this.match.google_place.photos || []
      }
      return []
    },

    photos: function() {
      var ary = []
      for(var i in this.google_photos) {
        ary.push("https://maps.googleapis.com/maps/api/place/photo?photoreference=" + this.google_photos[i]["photo_reference"] + "&key=AIzaSyBeG41-k-Yb9ke_Mzol_LiBYNvn62ZzBVg&maxwidth=1000")
      }
      if(this.match.yelp_business) {
        ary = ary.concat(this.match.yelp_business.photos)
      }
      ary.push(this.streetViewPhoto)
      return ary
    },

    preview_photos: function() {
      var leader = this.photos.length < 4 ? (this.photos.length) : 4
      if((this.photo_index + leader) <= (this.photos.length)) {
        return this.photos.slice(this.photo_index + 1, this.photo_index + leader)
      } else {
        return this.photos.slice(this.photo_index + 1, this.photos.length).concat(this.photos.slice(0, ((this.photos.length - 1) - (this.photo_index + 1)))).slice(0,3)
      }
    },

    streetViewPhoto: function() {
      let base = "https://maps.googleapis.com/maps/api/streetview?size=800x800&fov=90&key=AIzaSyBeG41-k-Yb9ke_Mzol_LiBYNvn62ZzBVg&source=outdoor&location="
      return encodeURI(base + [this.match.address1, this.match.city, this.match.state, this.match.zip].join(","))
    },
  },

  created: function() {
    this.setReviews()
  },

  data: function() {
    return {
      availability_requested: false,
      inquiryDialogIsVisible: false,
      photo_index: 0,
      reviews: [],
    }
  },

  methods: {
    nextPhoto: function() {
      this.photo_index += 1
      if(this.photo_index >= this.photos.length) { this.photo_index = 0 }
    },

    previousPhoto: function() {
      this.photo_index -= 1
      if(this.photo_index < 0) { this.photo_index = (this.photos.length - 1) }
    },

    requestAvailability: function() {
      this.availability_requested = true
      this.inquiryDialogIsVisible = true
      return true;
    },

    setReviews: function() {
      var ary = []
      if(this.match.google_place && this.match.google_place.reviews) {
        for(var r in this.match.google_place.reviews) {
          var review = this.match.google_place.reviews[r]
          ary.push({ author: review.author_name, year: new Date(review.time * 1000).getYear() + 1900, text: review.text, score: parseInt(review.rating), url: review.author_url, icon: this.$assets.icons.google })
        }
      } if(this.match.yelp_business && this.match.yelp_business.reviews) {
        for(var yr in this.match.yelp_business.reviews) {
          var yreview = this.match.yelp_business.reviews[yr]
          ary.push({ author: yreview.user.name, year: yreview.time_created.split("-")[0], text: yreview.text, score: parseInt(yreview.rating), url: yreview.url, icon: this.$assets.icons.yelp })
        }
      }
      this.reviews = ary
    },
  },

  props: ['match'],

  watch: {
    match: function() {
      this.photo_index = 0
      this.setReviews()
    }
  }
}
</script>
